import { useState } from "react";
import clsx from "clsx";

import { MediaItem } from "@/components/common/MediaItem";

import type { AdsLandingTestimonialTabs } from "./types";

export function TestimonialTabs({
  testimonialTabs,
}: {
  testimonialTabs: AdsLandingTestimonialTabs;
}) {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeTab = testimonialTabs.tabs[activeIndex];
  const testimonial = activeTab?.testimonial;

  if (testimonialTabs.tabs.length === 0 || !testimonial) {
    return null;
  }

  return (
    <div className="flex w-full flex-col items-center gap-10 pt-10">
      <div className="flex max-w-full items-center gap-1 overflow-x-auto rounded-[32px] border-[0.5px] border-[rgba(0,0,0,0.12)] bg-white p-1 shadow-[0_4px_34px_rgba(0,0,0,0.05)]">
        {testimonialTabs.tabs.map((tab, index) => {
          const isActive = index === activeIndex;

          return (
            <button
              key={`${tab.label}-${index}`}
              type="button"
              onClick={() => setActiveIndex(index)}
              className={clsx(
                "text-primary h-10 rounded-[32px] px-5 text-sm leading-none font-medium whitespace-nowrap",
                isActive && "border-[0.5px] border-[rgba(0,0,0,0.12)] bg-[rgba(0,0,0,0.02)]",
              )}
              data-analytics-action={tab.analyticsIdentifier}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      <div className="grid w-full grid-cols-1 md:grid-cols-12">
        <article
          key={activeIndex}
          className="flex w-full flex-col items-start gap-8 rounded-[6px] bg-[rgba(0,0,0,0.04)] p-8 md:col-span-6 md:col-start-4"
        >
          {testimonial.image ?
            <MediaItem {...testimonial.image} className="size-16 rounded-[6px]" />
          : null}
          {testimonial.quote ?
            <blockquote className="text-primary text-[17px] leading-7 text-balance">
              {testimonial.quote}
            </blockquote>
          : null}
          {testimonial.attribution ?
            <p className="text-secondary text-sm leading-[1.64]">{testimonial.attribution}</p>
          : null}
        </article>
      </div>
    </div>
  );
}
